import React from 'react'
import { MenuItem, TextField } from '@mui/material'
import { ComponentProps } from '../../../types/filters'

interface GenericFilterProps extends ComponentProps {
  fieldName: string
}

export const GenericFilter: React.FC<GenericFilterProps> = ({
  value,
  onChange,
  fullWidth = true,
  variant = 'outlined',
  fieldName
}) => {
  return (
    <TextField
      variant={variant}
      id={fieldName}
      name={fieldName}
      select
      value={value || ''}
      onChange={onChange}
      fullWidth={fullWidth}
    >
      <MenuItem value=''>Seleccionar Estado</MenuItem>
      <MenuItem value='true'>Sí</MenuItem>
      <MenuItem value='false'>No</MenuItem>
    </TextField>
  )
}
